import { Signal } from 'signals';
import graphicsManager from 'slotworks/graphics/graphics-manager';
import Layers from 'slotworks/graphics/layers/layers';
import soundManager from 'slotworks/sound/sound-manager';
import Contract from 'slotworks/utils/contract';
import Timer from 'slotworks/utils/timer';
import Poster from './poster';

class PosterTransitionComponent {
    public onStarted: Signal = new Signal();
    private posters: Poster[];
    private timer: number;
    private done: boolean;
    private endResolve: Function = null;

    public start() {
        return new Contract(resolve => {
            Layers.Custom.get('Poster').show();
            this.posters = [];
            this.done = false;
            soundManager.customEvent('FreeSpins_Transition');
            const texture = graphicsManager.getTexture('particles/wantedPoster');
            for (let i = 0; i < 7; i++) {
                const max = i % 2 ? 11 : 10;
                const start = i % 2 ? -50 : 100;
                for (let j = 0; j < max; j++) {
                    const sprite = new Poster(texture);
                    sprite.anchor.set(0.5, 0.5);
                    Layers.Custom.get('Poster').add(sprite);
                    sprite.x = start + 200 * j + Math.random() * 20;
                    sprite.y = 50 + 250 * i + Math.random() * 50;
                    sprite.rotation = -Math.random() * 0.08;
                    sprite.init();
                    this.posters.push(sprite);
                }
            }
            for (let i = 20; i > 0; i--) {
                const r = Math.floor(Math.random() * this.posters.length);
                this.bringToTop(this.posters[r]);
            }
            this.bringToTop(this.posters[24]);

            this.timer = Timer.setInterval(this.update, 1);
            Timer.setTimeout(() => {
                this.onStarted.dispatch();
                resolve(null);
            }, 1200);
        });
    }

    public end() {
        return new Contract(resolve => {
            if (this.done) {
                this.clean();
                resolve(null);
            } else {
                this.endResolve = resolve;
            }
        });
    }

    private update = () => {
        let done = true;
        for (let i = 0; i < this.posters.length; i++) {
            this.posters[i].update();
            if (!this.posters[i].finished()) {
                done = false;
            }
        }

        if (done) {
            this.clean();
            if (this.endResolve) {
                this.endResolve();
                this.endResolve = null;
            }
            this.done = true;
        }
    };

    private clean() {
        Timer.clearInterval(this.timer);
        for (let poster of this.posters) {
            Layers.Custom.get('Poster').remove(poster);
        }
        this.posters = [];
        Layers.Custom.get('Poster')
            .defaultScene()
            .execute();
    }

    private bringToTop(sprite: PIXI.Sprite) {
        const parent = sprite.parent;
        parent.removeChild(sprite);
        parent.addChild(sprite);
    }
}

const PosterTransition = new PosterTransitionComponent();
export default PosterTransition;



// WEBPACK FOOTER //
// ./src/components/poster-transition/poster-transition.ts